/* eslint-disable max-len */

import { NotifierTypes, WEBVIEW_NOTIFIER_TYPES } from './notifierConstants';

/* eslint-disable no-useless-escape */
export const IS_AUTHENTICATED = 'isAuthenticated';

export const DATE_FORMAT = 'dd MMM yyyy';

export const DATE_TIME_FORMAT = 'dd MMM yyyy, hh:mm:ss a';

export const DEFAULT_DATE_FORMAT = 'dd/MM/yyyy';

export const DEFAULT_TIME_FORMAT = 'hh:mm:ss a';

export const DATE_TIME_NO_SEC_FORMAT = 'dd MMM yyyy, hh:mm a';

export const REGEX = {
  email:
    /^[a-zA-Z0-9._%+-]+@(?!.*(\.\.|\.con|\.comn|\.cok|\.don|\.cim|gnail\.com|gmal\.com))([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/i,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
  name: /^[a-zA-Z][a-zA-Z .]*$|^$/,
  noWhiteSpace: /^(\S+$)/g,
  amount: /^(\d{0,5}(\.\d{0,2})?)$/,
  replceTrailingZeros: /^([\d,]+)$|^([\d,]+)\.0*$|^([\d,]+\.[0-9]*?)0*$/,

  // maximum 14 digits
  maximumTwoDecimals: /^(\d{0,14}(\.\d{0,2})?)$/,

  positiveWholeNumber: /^(\d{0,14})$/,
  exactlyThreeDecimals: /^[0-9]*\.[0-9]{3}$/,
  percentage: /^(\d{0,2}(\.\d{0,2})?)$|^([1][0][0])$/,
  percentageWithThreeDecimals: /^(\d{0,2}(\.\d{0,3})?)$/,

  decimalPoint: /^\.$/,
  phoneNumber: /^(\+91\d{10})$|^(\+63\d{10})$|^(\+1\d{10})$|^(\d{10})$/,
  usIndianNumber: /^(\+\d{11,12})$|^(\d{10})$/,
  phoneNumberInput:
    /^(\+(\d{1,2})?[\s]?\(?\d{0,3}\)?[\s-]?\d{0,3}[\s-]?\d{0,4})$|^([\s]?\(?\d{0,3}\)?[\s-]?\d{0,3}[\s-]?\d{0,5})$/,
  formatNumber: /^(1|)?(\d{3})(\d{3})(\d{4})$/,
  // detects anything other than a number
  nonNumber: /[^\d]/g,

  // regex for detecting anything other than  a number or dot
  nonNumberRegExp: /[^0-9.]/g,

  //regex for individual password characteristics
  containsUpperCase: /[A-Z]/,
  containsLowerCase: /[a-z]/,
  containsDigit: /[0-9]/,
  containsSpecialChar: /[!@#\$%\^&\*]/,
  facebookLinkRegex:
    /(?:(?:http|https):\/\/)?(?:www.)?facebook.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[?\w\-]*\/)?(?:profile.php\?id=(?=\d.*))?([\w\-]*)?/,
  yelpLinkRegex:
    /(?:(?:http|https):\/\/)?(?:www.)?yelp.com\/biz\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[?\w\-]*\/)?(?:profile.php\?id=(?=\d.*))?([\w\-]*)?/,

  websiteRegex: /(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+/,
  zipCode: /^\d{5}(?:[\-\s]\d{4})?$/,
  zipCodeOnChange: /^[0-9]+[-0-9]*$/,
  timeRegex: /^(0[1-9]|1[0-2]):[0-5][0-9]\s?(AM|PM)$/i,
  // eslint-disable-next-line no-control-regex
  asciiRegex: /^[\x00-\x7F]*$/
};

export const API_BASE_URL = {
  WEB_APP: 'web-app',
  BANKING: 'banking/master',
  JOB_MANAGER: 'job-manager',
  ESTIMATE_MANAGER: 'est-manager',
  VIEW_MANAGER: 'view-manager',
  TEAM_MANAGER: 'tm'
};

export const API_VERSION = {
  V1: 'v1',
  V2: 'v2',
  V3: 'v3',
  V4: 'v4',
  V5: 'v5',
  V6: 'v6',
  V7: 'v7',
  V8: 'v8'
};

export const API_SOURCE = {
  WEB: 'Web'
};

export const API_TAG_TYPES = {
  TEAM_VIEWS: 'GetTeamViews',
  GET_TILE_DATA: 'GetTileData',
  JOB_DETAILS: 'JobDetails',
  GET_SALES_BY_PAYMENT_METHODS: 'GetSalesByPaymentMethods',
  PAY_RUN_SETTINGS: 'PayRunSettings',
  PAY_PERIOD: 'PayPeriod',
  PAY_RUN_MEMBER_JOBS: 'PayRunMemberJobs',
  PAY_RUN_MEMBER_DETAILS: 'PayRunMemberDetails',
  PAY_RUN_CURRENT: 'PayRunCurrent',
  PAY_RUN_HISTORY: 'PayRunHistory',
  TEAM_MEMBER_DETAILS: 'TeamMemberDetails',
  GET_PROFITABILITY_SUMMARY: 'GetProfitabilitySummary',
  GET_JOB_EXPENSES: 'GetJobExpenses',
  EXTERNAL_COMPANY_JOBS: 'ExternalCompanyJobs',
  EXPENSE_REPORT: 'ExpenseReport',
  JOB_PROFITABILITY_REPORT: 'JobProfitabilityReport',
  BUSINESS_SUMMARY_REPORT: 'BusinessSummaryReport',
  SERVICE_AREAS: 'ServiceAreas',
  EXTERNAL_COMPANY: 'ExternalCompany',
  JOB_INIT: 'JobInit',
  TAGS: 'Tags',
  ADJUSTMENT_SETTINGS: 'AdjustmentSettings',
  SUGGESTED_ADJUSTMENTS_FOR_JOB: 'SuggestedAdjustmentsForJob',
  MERCHANT_CUSTOMIZATIONS: 'MerchantCustomizations',
  CUSTOMER_CARDS: 'CustomerCards',
  INVOICE_BY_ID: 'InvoiceById',
  CUSTOMERS: 'CustomersList',
  INVOICES_LIST: 'InvoicesList',
  FSM_SUBSCRIPTION: 'FSMSubscription',
  LIST_SUBSCRIPTION: 'ListSubscription',
  DISPUTES_LIST: 'DisputesList',
  GET_JOBS_FOR_MAP: 'GetJobsForMap',
  TEAM_BANK_ACCOUNTS: 'TeamBankAccounts'
};

export const API_TAG_TYPES_ARRAY = Object.values(API_TAG_TYPES);

export enum PopoverArrowTypes {
  TOP = 'top',
  RIGHT = 'right',
  BOTTOM = 'bottom',
  LEFT = 'left'
}

export enum TxnCardTypes {
  INVOICE = 'invoice',
  PAYOUT = 'payout',
  PAYOUT_DETAILS = 'payout details'
}

export enum TxnCardIconTypes {
  STATUS = 'Status',
  PAYMENT_METHOD = 'Payment Method'
}

export enum PaymentMethods {
  CARD = 'Credit / Debit Card',
  GOOGLEPAY = 'Google Pay',
  APPLEPAY = 'Apple Pay',
  GRABPAY = 'Grab Pay',
  PAYPAL = 'PayPal',
  PAYPAL_SCAN = 'paypal-scan',
  SPLITIT = 'Splitit',
  SGQR = 'SGQR',
  ACH = 'ACH',
  ACHBETA = 'ACH Beta',
  VENMO = 'Venmo',
  VENMO_SCAN = 'venmo-scan',
  CASHAPP = 'Cash App',
  KLARNA = 'Klarna',
  TINK = 'Tink',
  TRUELAYER = 'TrueLayer',
  CLICKTOPAY = 'Click To Pay',
  DEBIT_CARD = 'Credit / Debit Card',
  CREDIT_CARD = 'Credit / Debit Card',
  CASH_MANUAL = 'Cash',
  CHECK_MANUAL = 'Check',
  DIRECT_TRANSFER_MANUAL = 'Direct Transfer',
  OTHER_MANUAL = 'Other',
  MANUAL_KEY_IN = 'manual-key-in',
  SUNBIT = 'Sunbit',
  MOBILE_CHECK_DEPOSIT = 'Mobile check deposit',
  CARD_ON_FILE = 'card-on-file',
  AFFIRM = 'Affirm',
  AFTERPAY = 'Afterpay',
  TTP = 'TTP',
  ZELLE = 'Zelle'
}

export enum PaymentMethodKeys {
  CARD = 'card',
  GOOGLEPAY = 'gpay',
  CHECK = 'm-check',
  APPLEPAY = 'applepay',
  GRABPAY = 'grabpay',
  PAYPAL = 'paypal',
  PAYPAL_SCAN = 'paypal-scan',
  SPLITIT = 'splitit',
  SGQR = 'sgqr',
  ACH = 'ach',
  WIRE = 'wire',
  PHYSICAL = 'physical',
  VIRTUAL = 'virtual',
  ACHBETA = 'ach-beta',
  VENMO = 'venmo',
  VENMO_SCAN = 'venmo-scan',
  CASHAPP = 'cashapp',
  KLARNA = 'klarna',
  TINK = 'tink',
  TRUELAYER = 'truelayer',
  CLICKTOPAY = 'src',
  DIRECTTRANSFER = 'm-direct-transfer',
  CASH = 'm-cash',
  OTHER = 'm-other',
  MANUAL_KEY_IN = 'manual-key-in',
  TAP_AND_PAY = 'tap-and-pay',
  ZELLE = 'm-zelle',
  MOBILE_CHECK_DEPOST = 'Mobile check deposit',
  CHECK_DEPOSIT = 'check-deposit',
  CARD_ON_FILE = 'card-on-file',
  AFFIRM = 'affirm',
  AFTERPAY = 'afterpay',
  SUNBIT = 'sunbit'
}

export const PaymentMethodKeyNameLookup: { [key: string]: string } = {
  [PaymentMethodKeys.CARD]: 'Credit / debit card',
  [PaymentMethodKeys.GOOGLEPAY]: 'Google pay',
  [PaymentMethodKeys.CHECK]: 'Check',
  [PaymentMethodKeys.APPLEPAY]: 'Apple pay',
  [PaymentMethodKeys.GRABPAY]: 'Grab pay',
  [PaymentMethodKeys.PAYPAL]: 'Paypal',
  [PaymentMethodKeys.PAYPAL_SCAN]: 'Paypal (scan)',
  [PaymentMethodKeys.SPLITIT]: 'Splitit',
  [PaymentMethodKeys.SGQR]: 'Sgqr',
  [PaymentMethodKeys.ACH]: 'Ach',
  [PaymentMethodKeys.WIRE]: 'Wire transfer',
  [PaymentMethodKeys.PHYSICAL]: 'Physical card',
  [PaymentMethodKeys.VIRTUAL]: 'Virtual card',
  [PaymentMethodKeys.ACHBETA]: 'Ach beta',
  [PaymentMethodKeys.VENMO]: 'Venmo',
  [PaymentMethodKeys.VENMO_SCAN]: 'Venmo (scan)',
  [PaymentMethodKeys.CASHAPP]: 'Cash app',
  [PaymentMethodKeys.KLARNA]: 'Klarna',
  [PaymentMethodKeys.TINK]: 'Tink',
  [PaymentMethodKeys.TRUELAYER]: 'Truelayer',
  [PaymentMethodKeys.CLICKTOPAY]: 'Click to pay',
  [PaymentMethodKeys.DIRECTTRANSFER]: 'Direct transfer',
  [PaymentMethodKeys.CASH]: 'Cash',
  [PaymentMethodKeys.OTHER]: 'Other payment',
  [PaymentMethodKeys.MANUAL_KEY_IN]: 'Manual key-in',
  [PaymentMethodKeys.TAP_AND_PAY]: 'Tap and pay',
  [PaymentMethodKeys.ZELLE]: 'Zelle',
  [PaymentMethodKeys.MOBILE_CHECK_DEPOST]: 'Mobile check deposit',
  [PaymentMethodKeys.CHECK_DEPOSIT]: 'Check deposit',
  [PaymentMethodKeys.CARD_ON_FILE]: 'Card on file',
  [PaymentMethodKeys.AFFIRM]: 'Affirm',
  [PaymentMethodKeys.AFTERPAY]: 'Afterpay',
  [PaymentMethodKeys.SUNBIT]: 'Sunbit'
};

export const searchTypes = [
  {
    id: 'search-option-invoice-no',
    text: 'Invoice no.',
    searchText: 'Search with invoice number',
    type: 'invoiceNo'
  },
  {
    id: 'search-option-receipt-no',
    text: 'Receipt no.',
    searchText: 'Search with receipt number',
    type: 'receiptNo'
  },
  {
    id: 'search-option-card-no',
    text: 'Card no.',
    searchText: 'Search with Card no. (Last 4 digits)',
    type: 'cardNo'
  },
  {
    id: 'search-option-customer',
    text: 'Customer',
    searchText: 'Search with customer',
    type: 'customer'
  }
];

export enum LocalStorageKeysEnum {
  CURRENT_SIGN_IN_METHOD = 'currentSignInMethod',
  USER_DETAILS = 'userDetails',
  REDIRECT_URL = 'redirectUrl'
}

export const inValidDomains = ['..', '.con', '.comn', '.cok', '.don', '.cim', 'gnail.com', 'gmal.com'];

export const preventDefaultFn = (event: Event) => event.preventDefault();

export enum FILE_UPLOAD_SIZE {
  SIZE_8_MB_BYTES = 8388608,
  SIZE_5_MB_BYTES = 5242880,
  SIZE_1_MB = 1048576,
  SIZE_2_MB = 2097152,
  SIZE_1_POINT_5_MB = 1572864
}

export enum FILE_TYPE {
  PNG = 'image/png',
  JPEG = 'image/jpeg',
  JPG = 'image/jpg',
  WEBP = 'image/webp',
  PDF = 'application/pdf'
}

export enum DispatchDestination {
  SERVICE_CHARGE_SLICE = 'service_charge_slice',
  ITEMS_SLICE = 'items_slice',
  INVOICE_SLICE = 'invoice_slice',
  EDIT_INVOICE_SLICE = 'edit_invoice_slice'
}

export const nullFn = () => null;

export enum ECharLimits {
  INPUT_FIELD_DEFAULT = 50
}

export enum AmountFilterOperation {
  ALL = 'all',
  EQ = 'eq',
  LT = 'lt',
  GT = 'gt',
  BW = 'bw'
}

export enum FilterSelectionType {
  CHECKBOX = 'checkbox',
  RADIO = 'radio'
}

export enum WebviewFunctions {
  CLOSE_WEBVIEW = 'closeWebview',
  CLOSE_WEBVIEW_CHECKOUT = 'closeWebView',
  UPDATE_BANK_STATUS = 'updateBankAccountStatus',
  WEBVIEW_LOADED = 'webviewLoaded',
  ROUTE_TO_SHARE_INVOICE = 'routeToShareInvoice',
  ROUTE_TO_INVOICE_DETAIL = 'routeToInvoiceDetail',
  SHOW_TOAST = 'showToast',
  UPDATE_COF = 'updateCOF',
  TRACK_ANALYTICS_EVENT = 'trackAnalyticsEvent'
}

export interface ShowToastParams {
  message: string;
  type: WEBVIEW_NOTIFIER_TYPES;
}

export interface TrackAnalyticsEventParams {
  eventName: string;
  properties: Record<string, any>;
}

export const invoiceMinimumAmount = 0.5;

export enum ONBOARDING_URL_SOURCES {
  HOME = 'home',
  PAYOUT_SETTINGS = 'payout-settings'
}

export enum ONBOARDING_URL_PARAMS {
  FROM = 'from',
  IS_ADDITIONAL_BANK_ACCOUNT = 'isAdditionalBankAccount'
}

export enum LINE_ITEM_SOURCE {
  JOBS = 'jobs',
  INVOICES = 'invoices',
  EDIT_INVOICE = 'edit-invoice',
  ESTIMATES = 'estimates'
}

export enum DISCOUNT_TYPE {
  FLAT = 'FLAT',
  PERCENTAGE = 'PERCENTAGE'
}

export enum BUTTON_TYPE {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  DANGER = 'danger',
  LINK = 'link',
  GHOST = 'ghost'
}

export enum ENTITY_TYPE {
  JOB = 'JOB',
  INVOICE = 'INVOICE',
  ESTIMATE = 'ESTIMATE'
}

export const DOWNLOAD_NOTIFIER_TOAST = {
  message: {
    primaryMessage: 'Downloading started in the background',
    secondaryMessage: ''
  },
  type: NotifierTypes.INFO,
  showClose: false,
  fontStyle: 'text-primary font-normal',
  duration: 1800
};

export const JOB_MANAGER_API_HEADERS = {
  'X-App-Version': '2.0'
};

export enum PRESIGNED_UPLOAD_USE_CASE {
  ESTIMATES = 'ESTIMATES',
  JOBS = 'JOBS',
  INVOICE = 'INVOICE',
  INVOICE_AUTO_FILL = 'INVOICE_AUTO_FILL',
  JOB_AUTO_FILL = 'JOB_AUTO_FILL',
  ESTIMATE_AUTO_FILL = 'ESTIMATE_AUTO_FILL',
  DISPUTES = 'DISPUTES'
}
